import { CONFIG } from '../config'
import { KeyVal } from '../types'
import { HTTPService } from './http.service'

class ShopifyAdminService extends HTTPService {
  private endpoint: string = CONFIG.shopify.adminApiEndpoint

  constructor() {
    super({
      'X-Shopify-Access-Token': CONFIG.shopify.adminApiAccessToken,
      'x-cors-api-key': 'live_90a087e5647008a45ad9ee397a6d60ea0b5df69d0557a713c885bdb98cda89f2'
    })
  }

  async createCustomer(path: string, payload: KeyVal<any> = {}) {
    return this.post('https://proxy.cors.sh/' + this.endpoint + path, {
      customer: payload
    })
  }
}

export const shopifyAdminService = new ShopifyAdminService()
